import { render, staticRenderFns } from "./EventTemplateTable.vue?vue&type=template&id=5d1e0e61&scoped=true&"
import script from "./EventTemplateTable.vue?vue&type=script&lang=js&"
export * from "./EventTemplateTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1e0e61",
  null
  
)

export default component.exports